import { ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import type { SelectedFile } from './file-upload.component';

// --- File Upload Custom Validators ---
export function fileUploadMinValidator(min: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const files = control.value as Array<SelectedFile>;
    if (!Array.isArray(files)) return null;
    return files.length < min ? { MIN: true } : null;
  };
}

export function fileUploadMaxValidator(max: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const files = control.value as Array<SelectedFile>;
    if (!Array.isArray(files)) return null;
    return files.length > max ? { MAX: true } : null;
  };
}

export function fileUploadTotalSizeValidator(maxTotalSize: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const files = control.value as Array<SelectedFile>;
    if (!Array.isArray(files)) return null;
    let total = 0;
    files.forEach((file: SelectedFile) => total += file.file?.size || 0);
    return total > maxTotalSize ? { TOTAL_SIZE: true } : null;
  };
}

export function fileUploadSingleSizeValidator(maxSingleSize: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const files = control.value as Array<SelectedFile>;
    if (!Array.isArray(files)) return null;
    const result = files.find((file: SelectedFile) => (file.file?.size || 0) > maxSingleSize);
    return result !== undefined ? { SINGLE_SIZE: true } : null;
  };
}

export function fileUploadExtensionValidator(allowedTypes: Array<string>): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const files = control.value as Array<SelectedFile>;
    if (!Array.isArray(files) || !allowedTypes?.length) return null;
    for (const file of files) {
      if (allowedTypes.indexOf(file.file?.type) === -1) {
        return { EXTENSION: true };
      }
    }
    return null;
  };
}

export function fileUploadDuplicateValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const files = control.value as Array<SelectedFile>;
    if (!Array.isArray(files)) return null;
    for (const file of files) {
      const duplicates = files.filter((f: SelectedFile) => f.fileName === file.fileName);
      if (duplicates.length > 1) {
        return { DUPLICATES: true };
      }
    }
    return null;
  };
}
